import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from '../assets/agency-info-component.module.scss';
import InfoItem from 'src/components/InfoItem';

import { IAgencyInfo } from 'src/types/app';
import RenderFile from '../../../../../components/RenderFile';

const AgencyInfoComponent: React.FunctionComponent<IAgencyInfo> = (props: IAgencyInfo) => {
    const { name, snn, address, email, phone, logoDoc, logoDocMimeType, suffix, logoDocName, addressTwo, exigentHours, exigentAmount } = props;

    return (
        <div className={classNames(styles.tabWrap)}>
            <div className={classNames(styles.infoItems)}>
                <InfoItem title={'Name:'} value={name} />
                <InfoItem title={'Suffix:'} value={suffix} />
                <InfoItem title={'EIN # / SSN #:'} value={snn} />
                <InfoItem title={'Address:'} value={address} />
                <InfoItem title={'Address 2:'} value={addressTwo} />
                <InfoItem title={'Email:'} value={`${email}`} />
                <InfoItem title={'Phone Number:'} value={`${phone}`} />
                <InfoItem title={'Exigent Bonus Hours Limit:'} value={`${exigentHours}`} />
                <InfoItem title={'Exigent Bonus Amount:'} value={`${exigentAmount}`} />
                <InfoItem
                    title={'logo Doc:'}
                    value={
                        <a rel="noopener noreferrer" target="_blank" href={`${logoDoc}`}>
                            <RenderFile
                                file={{
                                    attach: logoDoc,
                                    mimeType: logoDocMimeType,
                                    name: logoDocName,
                                }}
                            />
                        </a>
                    }
                />
                {/* <InfoItem title={'Tax ID:'} value={taxId} />*/}
            </div>
            <div>
                <Link
                    className={classNames('btn', 'btn-outline-secondary')}
                    to={Router.generate(routes.AGENCY_INFO, { type: 'edit' })}
                >
                    EDIT
                </Link>
            </div>
        </div>
    );
};

export default AgencyInfoComponent;
